export default __webpack_public_path__ + "static/media/designPublicReview.515098f2.svg";